/**
 * Sistema de conversión de velocidades para Traccar
 * Interfaz siempre en km/h, almacenamiento siempre en nudos
 */


const KNOTS_TO_KMH_FACTOR = 1.852; //Factor de conversión: 1 nudo = 1.852 km/h

/**
 * Convierte velocidad de km/h a nudos (para almacenar en Traccar)
 * @param kmh Velocidad en km/h
 * @returns Velocidad en nudos
 */
export const kmhToKnots = (kmh: number): number => {
  if (kmh == null || isNaN(kmh)) return 0;
  return kmh / KNOTS_TO_KMH_FACTOR;
};

/**
 * Convierte velocidad de nudos a km/h (para mostrar en la interfaz)
 * @param knots Velocidad en nudos
 * @returns Velocidad en km/h
 */
export const knotsToKmh = (knots: number): number => {
  if (knots == null || isNaN(knots)) return 0;
  return knots * KNOTS_TO_KMH_FACTOR;
};

/**
 * Formatea velocidad en km/h con decimales opcionales
 * @param knots Velocidad en nudos (desde la BD)
 * @param decimals Número de decimales (default: 0)
 * @returns String formateado "XXX km/h"
 */
export const formatSpeedFromKnots = (knots: number, decimals: number = 0): string => {
  if (knots == null || isNaN(knots)) return '0 km/h';
  const kmh = knotsToKmh(knots);
  return `${kmh.toFixed(decimals)} km/h`;
};
